import { useCreateFloor } from "../api/useCreateFloor"
import { useDeleteFloor } from "../api/useDeleteFloor"
import { useDuplicateFloor } from "../api/useDuplicateFloor"
import { useUpdateFloor } from "../api/useUpdateFloor"

export function useFloorMutations() {
  const createFloor = useCreateFloor()
  const updateFloor = useUpdateFloor()
  const deleteFloor = useDeleteFloor()
  const duplicateFloor = useDuplicateFloor()

  return {
    createFloor,
    updateFloor,
    deleteFloor,
    duplicateFloor
  }
}
